import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// https://stackoverflow.com/questions/39152071/cant-bind-to-formgroup-since-it-isnt-a-known-property-of-form
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// https://stackoverflow.com/questions/47369850/property-get-does-not-exist-on-type-httpclientmodule
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FsrhComponent } from './fsrh/fsrh.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import { AdviseIudComponent } from './outcomes/advise-iud/advise-iud.component';
import { OutcomeElevenComponent } from './outcomes/outcome-eleven/outcome-eleven.component';
import { OutcomeTwelveComponent } from './outcomes/outcome-twelve/outcome-twelve.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule, MatFormFieldModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material';
import { MatNativeDateModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MAT_DATE_LOCALE } from '@angular/material';
import { MatSelectModule } from '@angular/material/select';

//import { IgxCalendarModule } from "igniteui-angular";
// https://stackoverflow.com/questions/35284988/angular-2-404-error-occur-when-i-refresh-through-the-browser
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatExpansionModule } from '@angular/material';
import { MatRadioModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material';
import { MatSliderModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { AbbreviationsComponent } from './abbreviations/abbreviations.component';
import { UPAECComponent } from './outcomes/upa-ec/upa-ec.component';
import { CustomDateAdapter } from './fsrh/fsrh.component';
import { DateAdapter } from '@angular/material';
import { OutcomeEightComponent } from './outcomes/outcome-eight/outcome-eight.component';
import { WithinFiveDaysOfOvulationComponent } from './outcomes/within-five-days-of-ovulation/within-five-days-of-ovulation.component';
import { TakingHormonalContraceptionComponent } from './taking-hormonal-contraception/taking-hormonal-contraception.component';
import { EnzymeInducerComponent } from './enzyme-inducer/enzyme-inducer.component';
import { Section1321Component } from './recomendation-section/section1321/section1321.component';
import { Section1322Component } from './recomendation-section/section1322/section1322.component';
import { Section103Component } from './recomendation-section/section103/section103.component';

@NgModule({
  declarations: [
    AppComponent,
    FsrhComponent,
    RecommendationsComponent,
    AdviseIudComponent,
    OutcomeElevenComponent,
    OutcomeTwelveComponent,
    AbbreviationsComponent,
    UPAECComponent,
    OutcomeEightComponent,
    WithinFiveDaysOfOvulationComponent,
    TakingHormonalContraceptionComponent,
    EnzymeInducerComponent,
    Section1321Component, Section1322Component, Section103Component
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSliderModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
   // IgxCalendarModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
